<template>
    <div v-for="info in devInfo"
        class="bg-white dark:bg-transparent dark:bg-[linear-gradient(91.95deg,_#3F1974_4.5%,_#502C86_96.91%)] p-px rounded-full min-w-[145px] max-w-[145px] text-center group">
        <div
            class="bg-white dark:bg-transparent dark:bg-[linear-gradient(167.97deg,rgba(18,2,44,0.7)_34.18%,rgba(57,14,95,0.7)_63.99%)] rounded-full p-px h-full">
            <NuxtImg format="webp" :src="info.img" alt="devs" width="143" height="143" class="rounded-full dark:grayscale group-hover:grayscale-0 transition-all duration-150" loading="lazy" />
            <div class="my-8 text-[var(--secondary-foreground)] flex flex-col gap-2">
                <h3 class="text-lg">{{ info.name }}</h3>
                <p class="text-xs px-2">{{info.exp}}</p>
                <div class="mt-1 flex flex-wrap justify-center gap-2 px-4">
                    <component v-for="tech in info.tech" :is="tech" class="size-5" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import WrFlutter from '../atoms/icons/WrFlutter.vue';
import WrLaravel from '../atoms/icons/WrLaravel.vue';
import WrNuxt from '../atoms/icons/WrNuxt.vue';
import WrReact from '../atoms/icons/WrReact.vue';
import WrVue from '../atoms/icons/WrVue.vue';

type DevInfo = {
    name?: string;
    img?: string;
    exp?: string;
    tech?: string[];
};

type Props = {
    appendClass?: string;
    devInfo?: DevInfo[];
};

const props = withDefaults(defineProps<Props>(), {
    devInfo: () => ([
        {
            img: '/images/dev-1.webp',
            name: 'Vikram Chand',
            exp: '10+ Years of experience in',
            tech: [markRaw(WrLaravel), markRaw(WrNuxt), markRaw(WrVue), markRaw(WrFlutter), markRaw(WrReact)],
        }
    ])
});
</script>